export const CART = "CART";
export const PRODUCTS = "PRODUCTS";
export const PROFILE = "PROFILE";
export const UID = "UID";
